import { Container } from 'inversify-props';
import TYPES from './types';
import FinancialInstitutionFetchRepository
  from './infrastructure/repository/financial-institution-fetch-repository';
import FinancialInstitutionDummyRepository
  from './infrastructure/repository/financial-institution-dummy-repository';
import VueStateManager from './infrastructure/state/vue-state-manager';
import { GetFinancialInstitutionsQueryService } from './application/queries';
import { FinancialInstitutionRepository } from './domain/repository';
import { StateManager } from './domain/state/state-manager';

const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';

export default function setupFinancialInstitution(container: Container) {
  container
    .bind<StateManager>(TYPES.ONBOARDING_FINANCIAL_INSTITUTION_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<FinancialInstitutionRepository>(TYPES.FINANCIAL_INSTITUTION_REPOSITORY)
    .to(
      withDummies
        ? FinancialInstitutionDummyRepository
        : FinancialInstitutionFetchRepository,
    )
    .inSingletonScope();

  container
    .bind<GetFinancialInstitutionsQueryService>(TYPES.GET_FINANCIAL_INSTITUTIONS_QUERY_SERVICE)
    .to(GetFinancialInstitutionsQueryService)
    .inSingletonScope();
}
